export default __webpack_public_path__ + "68f2d61e66fd6c0d08a88d7959bd2cf6.png";